import { SxProps } from "@mui/material";

export const sxTablePrincipal: SxProps = {
  borderRadius: '10px',
  width: '80%',
  '@media (max-width: 1135px)': {
      width: '60vw'
  },
  '@media (max-width: 1055px)': {
      width: '55vw'
  },
  '@media (max-width: 920px)': {
      width: '50vw'
  },
  '@media (max-width: 899px)': {
      width: '90vw'
  },
  '@media (max-width: 425px)': {
      width: '85vw'
  }
}

export const sxTable: SxProps = {
  borderRadius: '10px',
  width: '100%',
  '@media (max-width: 1135px)': {
      width: '60vw'
  },
  '@media (max-width: 1055px)': {
      width: '55vw'
  },
  '@media (max-width: 920px)': {
      width: '50vw'
  },
  '@media (max-width: 899px)': {
      width: '90vw'
  },
  '@media (max-width: 425px)': {
      width: '85vw'
  }
}

export const sxTableHead: SxProps = {
  '& th': {
    color: '#4C4C4C',
    fontFamily: 'Unimed-Sans',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px',
    padding: '16px 12px',
    borderBottom: '1px solid #E0E0E0',
    backgroundColor: '#fff',
  }
};

export const sxTableCell: SxProps = {
  color: '#383838',
  fontFamily: 'Unimed-Sans',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  padding: '16px 12px',
  borderBottom: '1px solid #E0E0E0',
};

export const sxTableCellBold: SxProps = {
  color: '#383838',
  fontFamily: 'UnimedSans-Bold',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '20px',
  padding: '16px 12px',
  borderBottom: '1px solid #E0E0E0',
};

export const sxCheckbox: SxProps = {
  color: '#00995D',
  '&.Mui-checked': {
    color: '#00995D',
  },
  '&.Mui-disabled': {
    color: '#9E9E9E',
  }
};

export const sxButtonGerarBoletPrincipal: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
  '@media (max-width: 720px)': {
      width: 'stretch'
  }
}


export const sxButtonGerarBoleto: SxProps = {
  borderRadius: '80px',
  height: '48px',
  padding: '12px 32px',
  backgroundColor: '#00995D',
  color: '#FFF',
  fontFamily: 'UnimedSans-Bold',
  fontSize: '16px',
  fontWeight: 700,
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: '#00834F',
  },
  '&:disabled': {
    backgroundColor: '#E0E0E0',
    color: '#9E9E9E',
  },
  '@media (max-width: 720px)': {
    width: '100%'
  }
};